module.exports = __webpack_public_path__ + "static/media/100_8.a4be0bbf.jpg";